// extracted by mini-css-extract-plugin
var _1 = "FormFieldReadOnlyTextValue-moduleFormFieldReadOnlyTextValue__JVw06";
export { _1 as "FormFieldReadOnlyTextValue" }
